var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{class:['cookie-banner', { 'cookie-banner--canada': _vm.isCanada }]},[_vm._t("default"),_c('button',{staticClass:"btn-close",on:{"click":_vm.close}},[_vm._t("close-btn")],2)],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }